<template>
  <div class="container">
    <div class="u-p-30 bg_FFFFFF u-b-r-8 u-m-t-40 u-m-b-100">
      <div class="u-font-14 cl_333 u-l-h-30" v-html="info.value"></div>
      <!-- <h3 class="u-text-center">一、应用技术类</h3>
      <div class="u-font-16 cl_333 fw_600 u-l-h-50">（一）财政性投入产生的科技成果须提供以下材料：</div>
      <div class="u-font-14 cl_333 u-l-h-30">
        1．科技计划项目验收或结项证书；<br>
        2．技术研究报告；<br>
        3．科技查新报告；<br>
        4．检测报告；<br>
        5．1篇SCI论文或2篇中文核心期刊（论文为发表5年以内，只提供成果登记第一完成人所发表的文章，其它完成人的文章不用提供）；<br>
        6．两家单位出具的应用佐证材料（需盖应用单位公章）。
      </div>
      <div class="u-font-16 cl_333 fw_600 u-l-h-50">（二）非财政性投入产生的科技成果须提供以下材料：</div>
      <div class="u-font-14 cl_333 u-l-h-30">
        1．技术研究报告；<br>
        2．科技查新报告；<br>
        3．检测报告；<br>
        4．1篇SCI论文或2篇中文核心期刊（论文为发表5年以内，只提供成果登记第一完成人所发表的文章，其它完成人的文章不用提供）；<br>
        5．两家单位出具的应用佐证材料（需盖应用单位公章）。
      </div>
      <h3 class="u-text-center">二、基础理论类</h3>
      <div class="u-font-16 cl_333 fw_600 u-l-h-50">（一）财政性投入产生的科技成果须提供以下材料：</div>
      <div class="u-font-14 cl_333 u-l-h-30">
        1．科技计划项目验收或结项证书；<br>
        2．研究报告；<br>
        3．科技查新报告；<br>
        4．1篇SCI论文或2篇中文核心期刊（论文须发表5年以内，只提供成果登记第一完成人所发表的文章，其它完成人的文章不用提供）或2部学术专著（只提供成果登记第一完成人的专著， 专著须发表5年以内）；<br>
        5．论文收录引用检索报告。
      </div>
      <div class="u-font-16 cl_333 fw_600 u-l-h-50">（二）非财政投入产生的科技成果须提供以下材料：</div>
      <div class="u-font-14 cl_333 u-l-h-30">
        1．研究报告；<br>
        2．科技查新报告；<br>
        3．1篇SCI论文或2篇中文核心期刊（论文须发表5年以内，只提供成果登记第一完成人所发表的文章，其它完成人的文章不用提供）或2部学术专著（只提供成果登记第一完成人的专著， 专著须发表5年以内）；<br>
        4．本单位学术部门（或学术委员会）等出具的评价意见；<br>
        5．论文收录引用检索报告。
      </div>
      <h3 class="u-text-center">三、软科学类</h3>
      <div class="u-font-16 cl_333 fw_600 u-l-h-50">（一）财政性投入产生的科技成果须提供以下材料：</div>
      <div class="u-font-14 cl_333 u-l-h-30">
        1．科技计划项目验收或结项证书；<br>
        2．研究报告；<br>
        3．科技查新报告；<br>
        4．1篇SCI论文或2篇中文核心期刊（论文须发表5年以内，只提供成果登记第一完成人所发表的文章，其它完成人的文章不用提供）或2部学术专著（只提供成果登记第一完成人的专著， 专著须发表5年以内）；<br>
        5．论文收录引用检索报告。
      </div>
      <div class="u-font-16 cl_333 fw_600 u-l-h-50">（二）非财政投入产生的科技成果须提供以下材料：</div>
      <div class="u-font-14 cl_333 u-l-h-30">
        1．研究报告；<br>
        2．科技查新报告；<br>
        3．1篇SCI论文或2篇中文核心期刊（论文须发表5年以内，只提供成果登记第一完成人所发表的文章，其它完成人的文章不用提供）或2部学术专著（只提供成果登记第一完成人的专著， 专著须发表5年以内）；<br>
        4．本单位学术部门（或学术委员会）等出具的评价意见；<br>
        5．论文收录引用检索报告。
      </div> -->
    </div>
  </div>
</template>

<script>
import { technologyAwardsConfig } from '@/api'

export default {
  data() {
    return {
      info: {}
    }
  },
  created() {
    this.getinfo()
  },
  methods: {
    getinfo(){
      technologyAwardsConfig().then(res => {
        if(res.code === 1){
          this.info = res.data.ta_content
        }
      })
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
/* 响应式设计 */
@media (max-width: 768px) {
 
}
</style>